const formaDePago = {
    DEPOSITO: 'Depósito / Transferencia Bancaria Anticipado',
    EFECTIVO: 'Efectivo contra entrega',
    TARJETA:  'Tarjeta de Crédito/Débito Pago Anticipado',
}

export default formaDePago;